export default __webpack_public_path__ + "static/media/chat3.053864a4.png";